import { useTranslation } from 'react-i18next';

import { Dropdown, DropdownItem, InlineAlert } from '@amzn/storm-ui';
import { FormRow } from '@amzn/storm-ui-column-form-kit';

import { ErrorDisplay } from '../../Shared/components/ErrorDisplay/ErrorDisplay';
import { ApiError } from '../../Shared/interfaces/ApiError';
import CustomSpinner from '../../UiComponentsLibrary/CustomSpinner';
import { Category } from '../interfaces/userInterfaces';

const CategoryDropDown = ({
  category,
  setCategory,
  categories,
  categoriesLoading,
  categoriesFetchingError,
  fieldError = '',
}: {
  category: string | null;
  setCategory: (value: string) => void;
  categories: Category[];
  categoriesLoading: boolean;
  categoriesFetchingError: ApiError | null;
  fieldError?: string;
}) => {
  const { t } = useTranslation();

  if (categoriesLoading) return <CustomSpinner />;
  if (categoriesFetchingError)
    return (
      <ErrorDisplay
        error={categoriesFetchingError}
        customMessage={t('category-failure')}
      />
    );

  return (
    <FormRow
      id="category"
      label={t('category-label')}
      controlComponents={[
        (componentId) => (
          <>
            <Dropdown
              id={componentId}
              selectedValue={category || ''}
              onChange={(value) => setCategory && setCategory(value)}
              disabled={categoriesLoading}
              error={!!fieldError}
            >
              {!category && (
                <DropdownItem
                  id="dropdown-item-category-placeholder"
                  value=""
                  disabled
                >
                  {t('category-placeholder')}
                </DropdownItem>
              )}
              {categories?.map(({ categoryName }: Category) => (
                <DropdownItem
                  key={categoryName}
                  id={`dropdown-item-category-${categoryName}`}
                  value={categoryName}
                >
                  {categoryName}
                </DropdownItem>
              ))}
            </Dropdown>
            {!!fieldError && (
              <InlineAlert message={fieldError} variant="error" />
            )}
          </>
        ),
      ]}
    />
  );
};

export default CategoryDropDown;
